{
  "GENERAL": {
    "CLOSE": "Lukk",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Søk",
      "EMPTY_STATE": "Ingen resultater funnet"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Minst {count} kreves"
  }
}
